export enum APDDailyWageEarner {
FiveDays,
SixDays,
}
